﻿import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
 
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  TextInput,
  FlatList,
  RefreshControl,
  Animated,
  ActivityIndicator,
  Alert,
} from 'react-native';
import { Ionicons, MaterialIcons, FontAwesome5 } from '@expo/vector-icons';
import * as DocumentPicker from 'expo-document-picker';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function MentorshipApplicationScreen({ navigation, route }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_mentorshipapplicationscreen`;
    apiFetch('/api/data/applications?sort=created_at&order=desc&limit=10').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [mentorshipDetails, setMentorshipDetails] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    education: '',
    experience: '',
    goals: '',
    availability: '',
    preferredMentors: [],
    documents: [],
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;

  // Mock mentorship data
  const mockMentorships = [
    {
      id: 'ment1',
      title: 'Women in Tech Mentorship',
      organization: 'TechWomen UK',
      location: 'Remote',
      type: 'Mentorship',
      field: 'Technology',
      deadline: '2025-07-25',
      duration: '6 months',
      logo: 'https://logo.clearbit.com/womenintech.co.uk',
      isRemote: true,
      description:
        'This mentorship program connects women in technology with experienced mentors to help advance their careers. Mentees will receive guidance on career development, technical skills, and leadership.',
      benefits: [
        'One-on-one mentoring sessions',
        'Career guidance and planning',
        'Technical skill development',
        'Networking opportunities',
        'Leadership training',
      ],
      eligibility: [
        'Women working in or studying technology',
        'At least 1 year of experience or education in tech',
        'Commitment to attend regular mentoring sessions',
      ],
      mentors: [
        {
          id: 'm1',
          name: 'Sarah Johnson',
          title: 'CTO at TechStart',
          expertise: 'Software Engineering, Leadership',
          image: 'https://randomuser.me/api/portraits/women/23.jpg',
        },
        {
          id: 'm2',
          name: 'Emily Chen',
          title: 'Senior Data Scientist at Google',
          expertise: 'Data Science, Machine Learning',
          image: 'https://randomuser.me/api/portraits/women/45.jpg',
        },
        {
          id: 'm3',
          name: 'Priya Patel',
          title: 'Engineering Manager at Microsoft',
          expertise: 'Product Development, Team Management',
          image: 'https://randomuser.me/api/portraits/women/67.jpg',
        },
      ],
      schedule: 'Flexible, 2-4 hours per month',
      applicationDeadline: '2025-07-25',
    },
    {
      id: 'ment2',
      title: 'Engineering Leadership Mentoring',
      organization: 'Royal Academy of Engineering',
      location: 'London, Remote',
      type: 'Mentorship',
      field: 'Engineering',
      deadline: '2025-08-20',
      duration: '12 months',
      logo: 'https://logo.clearbit.com/raeng.org.uk',
      isRemote: true,
      description:
        'This program pairs early and mid-career engineers with experienced leaders in the field. The focus is on developing leadership skills, strategic thinking, and career advancement in engineering disciplines.',
      benefits: [
        'Structured leadership development',
        'Industry insights and connections',
        'Career progression strategies',
        'Professional development workshops',
        'Access to engineering leadership network',
      ],
      eligibility: [
        'Engineers with 3-10 years of experience',
        'Demonstrated potential for leadership',
        'Commitment to the full 12-month program',
      ],
      mentors: [
        {
          id: 'm4',
          name: 'Dr. James Wilson',
          title: 'Director of Engineering at Rolls-Royce',
          expertise: 'Mechanical Engineering, Leadership',
          image: 'https://randomuser.me/api/portraits/men/32.jpg',
        },
        {
          id: 'm5',
          name: 'Dr. Elizabeth Taylor',
          title: 'Professor of Civil Engineering at Imperial College',
          expertise: 'Structural Engineering, Research',
          image: 'https://randomuser.me/api/portraits/women/28.jpg',
        },
        {
          id: 'm6',
          name: 'Robert Chen',
          title: 'VP of Engineering at Siemens',
          expertise: 'Electrical Engineering, Project Management',
          image: 'https://randomuser.me/api/portraits/men/54.jpg',
        },
      ],
      schedule: 'Monthly meetings plus quarterly workshops',
      applicationDeadline: '2025-08-20',
    },
    {
      id: 'ment3',
      title: 'Finance Career Mentorship',
      organization: 'CIMA',
      location: 'Remote',
      type: 'Mentorship',
      field: 'Finance',
      deadline: '2025-06-30',
      duration: '9 months',
      logo: 'https://logo.clearbit.com/cimaglobal.com',
      isRemote: true,
      description:
        'This mentorship program is designed for finance professionals looking to advance their careers. Mentees will receive guidance on professional qualifications, career paths, and developing specialized expertise in finance.',
      benefits: [
        'Career path guidance',
        'Professional qualification advice',
        'Industry networking',
        'Skill development in specialized areas',
        'Work-life balance strategies',
      ],
      eligibility: [
        'Finance professionals at any career stage',
        'CIMA members or students (preferred but not required)',
        'Commitment to professional development',
      ],
      mentors: [
        {
          id: 'm7',
          name: 'Michael Thompson',
          title: 'CFO at Barclays UK',
          expertise: 'Corporate Finance, Banking',
          image: 'https://randomuser.me/api/portraits/men/76.jpg',
        },
        {
          id: 'm8',
          name: 'Sophia Williams',
          title: 'Finance Director at Deloitte',
          expertise: 'Accounting, Auditing',
          image: 'https://randomuser.me/api/portraits/women/33.jpg',
        },
        {
          id: 'm9',
          name: 'David Lee',
          title: 'Investment Manager at BlackRock',
          expertise: 'Investment, Asset Management',
          image: 'https://randomuser.me/api/portraits/men/41.jpg',
        },
      ],
      schedule: 'Bi-weekly sessions, flexible timing',
      applicationDeadline: '2025-06-30',
    },
  ];

  // Load mentorship details
  useEffect(() => {
    if (!route.params?.mentorshipId) {
      setErrors({ general: 'No mentorship ID provided' });
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      const mentorship = mockMentorships.find(
        m => m.id === route.params.mentorshipId
      );

      if (mentorship) {
        setMentorshipDetails(mentorship);
      } else {
        setErrors({ general: 'Mentorship not found' });
      }

      setIsLoading(false);

      // Animate content in
      Animated.parallel([
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
        Animated.timing(slideAnim, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }),
      ]).start();
    }, 1500);
  }, [route.params?.mentorshipId, fadeAnim, slideAnim]);

  // Format date
  const formatDate = dateString => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Handle form input change
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    // Clear error for this field if it exists
    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  // Handle mentor selection
  const handleMentorSelection = mentorId => {
    setFormData(prev => {
      const currentSelection = [...prev.preferredMentors];

      if (currentSelection.includes(mentorId)) {
        // Remove mentor if already selected
        return {
          ...prev,
          preferredMentors: currentSelection.filter(id => id !== mentorId),
        };
      } else {
        // Add mentor if not already selected (max 2)
        if (currentSelection.length < 2) {
          return {
            ...prev,
            preferredMentors: [...currentSelection, mentorId],
          };
        }
        return prev;
      }
    });
  };

  // Handle document upload
  const handleDocumentUpload = async documentType => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ],
        copyToCacheDirectory: true,
      });

      if (result.canceled) {
        return;
      }

      const newDocument = {
        type: documentType,
        name: result.assets[0].name,
        uri: result.assets[0].uri,
        size: result.assets[0].size,
      };

      setFormData(prev => ({
        ...prev,
        documents: [
          ...prev.documents.filter(doc => doc.type !== documentType),
          newDocument,
        ],
      }));
    } catch (error) {
      Alert.alert('Error', 'Failed to upload document. Please try again.');
    }
  };

  // Validate form data
  const validateForm = () => {
    const newErrors = {};

    // Step 1 validation
    if (currentStep === 1) {
      if (!formData.firstName.trim())
        newErrors.firstName = 'First name is required';
      if (!formData.lastName.trim())
        newErrors.lastName = 'Last name is required';
      if (!formData.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email is invalid';
      }
      if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    }

    // Step 2 validation
    if (currentStep === 2) {
      if (!formData.education.trim())
        newErrors.education = 'Education information is required';
      if (!formData.experience.trim())
        newErrors.experience = 'Experience information is required';
    }

    // Step 3 validation
    if (currentStep === 3) {
      if (!formData.goals.trim()) newErrors.goals = 'Goals are required';
      if (!formData.availability.trim())
        newErrors.availability = 'Availability information is required';
      if (formData.preferredMentors.length === 0)
        newErrors.preferredMentors =
          'Please select at least one preferred mentor';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle next step
  const handleNextStep = () => {
    if (validateForm()) {
      setCurrentStep(prev => prev + 1);

      // Scroll to top when changing steps
      setTimeout(() => {
        if (scrollViewRef.current) {
          scrollViewRef.current.scrollTo({ y: 0, animated: true });
        }
      }, 100);
    }
  };

  // Handle previous step
  const handlePrevStep = () => {
    setCurrentStep(prev => Math.max(1, prev - 1));

    // Scroll to top when changing steps
    setTimeout(() => {
      if (scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y: 0, animated: true });
      }
    }, 100);
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      setIsSubmitting(true);

      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);

        // Show success message
        Alert.alert(
          'Application Submitted',
          `Your application for ${mentorshipDetails.title} has been submitted successfully. You will receive a confirmation email shortly.`,
          [
            {
              text: 'OK',
              onPress: () => navigation.navigate('MentorshipPrograms'),
            },
          ]
        );
      }, 2000);
    }
  };

  // Scroll view reference
  const scrollViewRef = useRef(null);

  // Render error state
  const renderError = () => (
    <View style={styles.errorContainer}>
      <Ionicons name="alert-circle-outline" size={60} color="#EF4444" />
      <Text style={styles.errorTitle}>Error</Text>
      <Text style={styles.errorMessage}>
        {errors.general || 'An unexpected error occurred'}
      </Text>
      <TouchableOpacity
        style={styles.errorButton}
        onPress={() => navigation.goBack()}
      >
        <Text style={styles.errorButtonText}>Go Back</Text>
      </TouchableOpacity>
    </View>
  );

  // Render step indicator
  const renderStepIndicator = () => (
    <View style={styles.stepIndicatorContainer}>
      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 1 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 1 && styles.activeStepNumber,
            ]}
          >
            1
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 1 && styles.activeStepLabel]}
        >
          Personal Info
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 2 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 2 && styles.activeStepNumber,
            ]}
          >
            2
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 2 && styles.activeStepLabel]}
        >
          Background
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 3 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 3 && styles.activeStepNumber,
            ]}
          >
            3
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 3 && styles.activeStepLabel]}
        >
          Preferences
        </Text>
      </View>

      <View style={styles.stepConnector} />

      <View style={styles.stepIndicator}>
        <View
          style={[
            styles.stepCircle,
            currentStep >= 4 && styles.activeStepCircle,
          ]}
        >
          <Text
            style={[
              styles.stepNumber,
              currentStep >= 4 && styles.activeStepNumber,
            ]}
          >
            4
          </Text>
        </View>
        <Text
          style={[styles.stepLabel, currentStep >= 4 && styles.activeStepLabel]}
        >
          Review
        </Text>
      </View>
    </View>
  );

  // Render step 1: Personal Information
  const renderStep1 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Personal Information</Text>
      <Text style={styles.stepDescription}>
        Please provide your personal details for the mentorship application.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>First Name *</Text>
        <TextInput
          style={[styles.input, errors.firstName && styles.inputError]}
          placeholder="Enter your first name"
          value={formData.firstName}
          onChangeText={text => handleInputChange('firstName', text)}
        />
        {errors.firstName && (
          <Text style={styles.errorText}>{errors.firstName}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Last Name *</Text>
        <TextInput
          style={[styles.input, errors.lastName && styles.inputError]}
          placeholder="Enter your last name"
          value={formData.lastName}
          onChangeText={text => handleInputChange('lastName', text)}
        />
        {errors.lastName && (
          <Text style={styles.errorText}>{errors.lastName}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Email Address *</Text>
        <TextInput
          style={[styles.input, errors.email && styles.inputError]}
          placeholder="Enter your email address"
          keyboardType="email-address"
          autoCapitalize="none"
          value={formData.email}
          onChangeText={text => handleInputChange('email', text)}
        />
        {errors.email && <Text style={styles.errorText}>{errors.email}</Text>}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Phone Number *</Text>
        <TextInput
          style={[styles.input, errors.phone && styles.inputError]}
          placeholder="Enter your phone number"
          keyboardType="phone-pad"
          value={formData.phone}
          onChangeText={text => handleInputChange('phone', text)}
        />
        {errors.phone && <Text style={styles.errorText}>{errors.phone}</Text>}
      </View>
    </View>
  );

  // Render step 2: Background Information
  const renderStep2 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Background Information</Text>
      <Text style={styles.stepDescription}>
        Please provide information about your education and experience.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Education Background *</Text>
        <TextInput
          style={[styles.textArea, errors.education && styles.inputError]}
          placeholder="Enter your educational background, including degrees, institutions, and graduation years"
          multiline
          numberOfLines={4}
          textAlignVertical="top"
          value={formData.education}
          onChangeText={text => handleInputChange('education', text)}
        />
        {errors.education && (
          <Text style={styles.errorText}>{errors.education}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Professional Experience *</Text>
        <TextInput
          style={[styles.textArea, errors.experience && styles.inputError]}
          placeholder="Describe your professional experience, including current role, previous positions, and relevant achievements"
          multiline
          numberOfLines={4}
          textAlignVertical="top"
          value={formData.experience}
          onChangeText={text => handleInputChange('experience', text)}
        />
        {errors.experience && (
          <Text style={styles.errorText}>{errors.experience}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Supporting Documents (Optional)</Text>
        <Text style={styles.inputDescription}>
          Upload your resume and any other relevant documents.
        </Text>

        <TouchableOpacity
          style={styles.uploadButton}
          onPress={() => handleDocumentUpload('resume')}
        >
          <Ionicons name="document-outline" size={20} color="#0e4e96" />
          <Text style={styles.uploadButtonText}>
            {formData.documents.find(doc => doc.type === 'resume')
              ? 'Resume Uploaded'
              : 'Upload Resume/CV'}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.uploadButton}
          onPress={() => handleDocumentUpload('portfolio')}
        >
          <Ionicons name="folder-outline" size={20} color="#0e4e96" />
          <Text style={styles.uploadButtonText}>
            {formData.documents.find(doc => doc.type === 'portfolio')
              ? 'Portfolio Uploaded'
              : 'Upload Portfolio (Optional)'}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  // Render step 3: Mentorship Preferences
  const renderStep3 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Mentorship Preferences</Text>
      <Text style={styles.stepDescription}>
        Please provide information about your goals and preferences for this
        mentorship.
      </Text>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Mentorship Goals *</Text>
        <TextInput
          style={[styles.textArea, errors.goals && styles.inputError]}
          placeholder="Describe what you hope to achieve through this mentorship program"
          multiline
          numberOfLines={4}
          textAlignVertical="top"
          value={formData.goals}
          onChangeText={text => handleInputChange('goals', text)}
        />
        {errors.goals && <Text style={styles.errorText}>{errors.goals}</Text>}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Availability *</Text>
        <TextInput
          style={[styles.textArea, errors.availability && styles.inputError]}
          placeholder="Describe your availability for mentorship sessions (days, times, frequency)"
          multiline
          numberOfLines={4}
          textAlignVertical="top"
          value={formData.availability}
          onChangeText={text => handleInputChange('availability', text)}
        />
        {errors.availability && (
          <Text style={styles.errorText}>{errors.availability}</Text>
        )}
      </View>

      <View style={styles.formGroup}>
        <Text style={styles.inputLabel}>Preferred Mentors *</Text>
        <Text style={styles.inputDescription}>
          Select up to 2 preferred mentors. This helps us match you with the
          most suitable mentor.
        </Text>
        {errors.preferredMentors && (
          <Text style={styles.errorText}>{errors.preferredMentors}</Text>
        )}

        {mentorshipDetails?.mentors.map(mentor => (
          <TouchableOpacity
            key={mentor.id}
            style={[
              styles.mentorOption,
              formData.preferredMentors.includes(mentor.id) &&
                styles.selectedMentorOption,
            ]}
            onPress={() => handleMentorSelection(mentor.id)}
          >
            <View style={styles.mentorOptionLeft}>
              <Image
                source={{ uri: (mentor.image && typeof mentor.image=="string" && mentor.image.startsWith("http")) ? mentor.image : undefined }}
                style={styles.mentorImage}
                defaultSource={require('../../../assets/default-profile.png')}
              />
              <View style={styles.mentorInfo}>
                <Text style={styles.mentorName}>{mentor.name}</Text>
                <Text style={styles.mentorTitle}>{mentor.title}</Text>
                <Text style={styles.mentorExpertise}>{mentor.expertise}</Text>
              </View>
            </View>
            <View style={styles.mentorOptionRight}>
              <View
                style={[
                  styles.checkCircle,
                  formData.preferredMentors.includes(mentor.id) &&
                    styles.checkedCircle,
                ]}
              >
                {formData.preferredMentors.includes(mentor.id) && (
                  <Ionicons name="checkmark" size={16} color="#ffffff" />
                )}
              </View>
            </View>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );

  // Render step 4: Review and Submit
  const renderStep4 = () => (
    <View style={styles.stepContainer}>
      <Text style={styles.stepTitle}>Review and Submit</Text>
      <Text style={styles.stepDescription}>
        Please review your application details before submitting.
      </Text>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Mentorship Program</Text>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Program:</Text>
          <Text style={styles.reviewItemValue}>{mentorshipDetails?.title}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Organization:</Text>
          <Text style={styles.reviewItemValue}>
            {mentorshipDetails?.organization}
          </Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Duration:</Text>
          <Text style={styles.reviewItemValue}>
            {mentorshipDetails?.duration}
          </Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Deadline:</Text>
          <Text style={styles.reviewItemValue}>
            {formatDate(mentorshipDetails?.applicationDeadline)}
          </Text>
        </View>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Personal Information</Text>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Name:</Text>
          <Text
            style={styles.reviewItemValue}
          >{`${formData.firstName} ${formData.lastName}`}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Email:</Text>
          <Text style={styles.reviewItemValue}>{formData.email}</Text>
        </View>
        <View style={styles.reviewItem}>
          <Text style={styles.reviewItemLabel}>Phone:</Text>
          <Text style={styles.reviewItemValue}>{formData.phone}</Text>
        </View>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Mentorship Goals</Text>
        <Text style={styles.reviewParagraph}>{formData.goals}</Text>
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Preferred Mentors</Text>
        {formData.preferredMentors.map(mentorId => {
          const mentor = mentorshipDetails?.mentors.find(
            m => m.id === mentorId
          );
          return mentor ? (
            <View key={mentor.id} style={styles.reviewItem}>
              <Text style={styles.reviewItemLabel}>Mentor:</Text>
              <Text style={styles.reviewItemValue}>
                {mentor.name} - {mentor.title}
              </Text>
            </View>
          ) : null;
        })}
      </View>

      <View style={styles.reviewSection}>
        <Text style={styles.reviewSectionTitle}>Uploaded Documents</Text>
        {formData.documents.length > 0 ? (
          formData.documents.map(doc => (
            <View key={doc.type} style={styles.reviewItem}>
              <Text style={styles.reviewItemLabel}>
                {doc.type === 'resume' ? 'Resume:' : 'Portfolio:'}
              </Text>
              <Text style={styles.reviewItemValue}>{doc.name}</Text>
            </View>
          ))
        ) : (
          <Text style={styles.reviewParagraph}>No documents uploaded</Text>
        )}
      </View>

      <View style={styles.termsContainer}>
        <Text style={styles.termsText}>
          By submitting this application, you agree to our Terms of Service and
          Privacy Policy. You also confirm that all information provided is
          accurate and complete.
        </Text>
      </View>
    </View>
  );

  // Render step content based on current step
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      default:
        return null;
    }
  };

  // Render navigation buttons
  const renderNavButtons = () => (
    <View style={styles.navButtonsContainer}>
      {currentStep > 1 && (
        <TouchableOpacity style={styles.prevButton} onPress={handlePrevStep}>
          <Ionicons name="arrow-back" size={20} color="#0e4e96" />
          <Text style={styles.prevButtonText}>Previous</Text>
        </TouchableOpacity>
      )}

      {currentStep < 4 ? (
        <TouchableOpacity style={styles.nextButton} onPress={handleNextStep}>
          <Text style={styles.nextButtonText}>Next</Text>
          <Ionicons name="arrow-forward" size={20} color="#ffffff" />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          style={styles.submitButton}
          onPress={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <ActivityIndicator size={20} color="#ffffff" />
          ) : (
            <>
              <Text style={styles.submitButtonText}>Submit Application</Text>
              <Ionicons name="checkmark" size={20} color="#ffffff" />
            </>
          )}
        </TouchableOpacity>
      )}
    </View>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Mentorship Application</Text>
        <JobengLogo />
      </View>

      {/* Mentorship Info */}
      {!isLoading && mentorshipDetails && (
        <View style={styles.mentorshipInfoContainer}>
          <View style={styles.mentorshipLogoContainer}>
            <Image
              source={{ uri: (mentorshipDetails.logo && mentorshipDetails.logo.startsWith('http')) ? mentorshipDetails.logo : undefined }}
              style={styles.mentorshipLogo}
              defaultSource={require('../../../assets/default-company.png')}
            />
          </View>
          <View style={styles.mentorshipInfoContent}>
            <Text style={styles.mentorshipTitle} numberOfLines={2}>
              {mentorshipDetails.title}
            </Text>
            <Text style={styles.mentorshipOrganization}>
              {mentorshipDetails.organization}
            </Text>
            <View style={styles.mentorshipDetailsRow}>
              <View style={styles.mentorshipDetailItem}>
                <Ionicons name="time-outline" size={14} color="#64748B" />
                <Text style={styles.mentorshipDetailText}>
                  {mentorshipDetails.duration}
                </Text>
              </View>
              <View style={styles.mentorshipDetailItem}>
                <Ionicons name="location-outline" size={14} color="#64748B" />
                <Text style={styles.mentorshipDetailText}>
                  {mentorshipDetails.location}
                </Text>
              </View>
            </View>
          </View>
        </View>
      )}

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading mentorship details...</Text>
        </View>
      ) : errors.general ? (
        renderError()
      ) : (
        <Animated.View
          style={[
            styles.contentContainer,
            {
              opacity: fadeAnim,
              transform: [{ translateY: slideAnim }],
            },
          ]}
        >
          {/* Step Indicator */}
          {renderStepIndicator()}

          {/* Form Content */}
          <ScrollView
            ref={scrollViewRef}
            style={styles.scrollView}
            contentContainerStyle={styles.scrollViewContent}
            showsVerticalScrollIndicator={false}
          >
            {renderStepContent()}

            {/* Navigation Buttons */}
            {renderNavButtons()}

            {/* Bottom Padding */}
            <View style={styles.bottomPadding} />
          </ScrollView>
        </Animated.View>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  mentorshipInfoContainer: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  mentorshipLogoContainer: {
    marginRight: 12,
  },
  mentorshipLogo: {
    width: 50,
    height: 50,
    borderRadius: 8,
    backgroundColor: '#F1F5F9',
  },
  mentorshipInfoContent: {
    flex: 1,
  },
  mentorshipTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 4,
  },
  mentorshipOrganization: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 4,
  },
  mentorshipDetailsRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mentorshipDetailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  mentorshipDetailText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
  },
  contentContainer: {
    flex: 1,
  },
  stepIndicatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  stepIndicator: {
    alignItems: 'center',
  },
  stepCircle: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#F1F5F9',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
  },
  activeStepCircle: {
    backgroundColor: '#0e4e96',
  },
  stepNumber: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#64748B',
  },
  activeStepNumber: {
    color: '#ffffff',
  },
  stepLabel: {
    fontSize: 12,
    color: '#64748B',
  },
  activeStepLabel: {
    color: '#0e4e96',
    fontWeight: '500',
  },
  stepConnector: {
    flex: 1,
    height: 2,
    backgroundColor: '#E2E8F0',
    marginHorizontal: 4,
  },
  scrollView: {
    flex: 1,
  },
  scrollViewContent: {
    paddingBottom: 20,
  },
  stepContainer: {
    padding: 20,
    backgroundColor: '#ffffff',
    marginHorizontal: 16,
    marginTop: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  stepTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 8,
  },
  stepDescription: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 20,
  },
  formGroup: {
    marginBottom: 20,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 8,
  },
  inputDescription: {
    fontSize: 12,
    color: '#64748B',
    marginBottom: 8,
  },
  input: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: '#0F172A',
  },
  inputError: {
    borderColor: '#EF4444',
  },
  errorText: {
    fontSize: 12,
    color: '#EF4444',
    marginTop: 4,
  },
  textArea: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: '#0F172A',
    minHeight: 100,
  },
  uploadButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginBottom: 10,
  },
  uploadButtonText: {
    fontSize: 14,
    color: '#0F172A',
    marginLeft: 8,
  },
  mentorOption: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
  },
  selectedMentorOption: {
    borderColor: '#0e4e96',
    backgroundColor: '#F0F9FF',
  },
  mentorOptionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  mentorImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  mentorInfo: {
    flex: 1,
  },
  mentorName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 2,
  },
  mentorTitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 2,
  },
  mentorExpertise: {
    fontSize: 12,
    color: '#94A3B8',
  },
  mentorOptionRight: {
    marginLeft: 12,
  },
  checkCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#CBD5E1',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkedCircle: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  reviewSection: {
    marginBottom: 20,
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
  },
  reviewSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 12,
  },
  reviewItem: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  reviewItemLabel: {
    fontSize: 14,
    color: '#64748B',
    width: 100,
  },
  reviewItemValue: {
    fontSize: 14,
    color: '#0F172A',
    flex: 1,
    fontWeight: '500',
  },
  reviewParagraph: {
    fontSize: 14,
    color: '#0F172A',
    lineHeight: 20,
  },
  termsContainer: {
    marginBottom: 20,
  },
  termsText: {
    fontSize: 12,
    color: '#64748B',
    lineHeight: 18,
  },
  navButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 16,
    marginTop: 20,
  },
  prevButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  prevButtonText: {
    fontSize: 16,
    color: '#0e4e96',
    fontWeight: '600',
    marginLeft: 8,
  },
  nextButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginLeft: 'auto',
  },
  nextButtonText: {
    fontSize: 16,
    color: '#ffffff',
    fontWeight: '600',
    marginRight: 8,
  },
  submitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginLeft: 'auto',
  },
  submitButtonText: {
    fontSize: 16,
    color: '#ffffff',
    fontWeight: '600',
    marginRight: 8,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748B',
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0F172A',
    marginTop: 16,
    marginBottom: 8,
  },
  errorMessage: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    marginBottom: 20,
  },
  errorButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  errorButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  bottomPadding: {
    height: 40,
  },
});
